import { render, staticRenderFns } from "./UserAssingRolesModalList.vue?vue&type=template&id=a20ef97a&scoped=true&"
import script from "./UserAssingRolesModalList.vue?vue&type=script&lang=js&"
export * from "./UserAssingRolesModalList.vue?vue&type=script&lang=js&"
import style0 from "./UserAssingRolesModalList.vue?vue&type=style&index=0&id=a20ef97a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20ef97a",
  null
  
)

export default component.exports